import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/portfolio/performanceDrivers/staffing";

const SalesPerHeadCategorisation = () => {
    const salesPerHeadCategorisation = useSelector(state => selectors.salesPerHeadCategorisation(state));
    const { loading, error, id, label, status, value } = salesPerHeadCategorisation;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default SalesPerHeadCategorisation;
